import React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';

import { FilterFormProps } from './popoverDialog';
import { BaseAlertsFilter } from './baseAlertsFilter';

export const DeviceAlertsFilter: React.FC<FilterFormProps> = ({ close }) => {
  const { t } = useTranslation(['translation', 'batteryEssentialsDeviceView']);

  const alertConfig = {
    statusHeaderLabel: t('AVERAGE_DISCHARGE_STATUS_HEADER', { ns: 'batteryEssentialsDeviceView' })
  };

  return <BaseAlertsFilter close={close} alertConfig={alertConfig} className="alerts-filter--device-status" />;
};
